import React from 'react';

import Modal from "components/common/modal";
import OverViewContainer from 'components/pages/overview/overviewcontainer';

export default class Overview extends React.Component {
    componentDidMount() {
        // let seenPopup = sessionStorage.getItem('seenPopup');
        // if (!seenPopup) {
        //     this.popupModal.open();
        //     sessionStorage.setItem('seenPopup', true);
        // }
    }

    render() {
        return (
            <React.Fragment >
                <OverViewContainer />
                <Modal
                    ref={(elem) => { this.popupModal = elem }}
                    clickButton={(e) => { this.popupModal.close() }}
                    header={"New website"}
                    buttonText={"Got it"}
                    buttonClass="btn-success"
                    entry={null}
                    onClose={() => { }}
                >
                    <div>
                        Dear clients,<br></br><br></br>Please take note:<br></br><br></br>On <b>Friday 27th July 2018</b>, the SenzoLive software URL will be changed to <b>https://software.senzolive.com</b><br></br><br></br>The current https://senzolive.com will become the URL for our new website. You will be able to access the software by clicking the login button on the website.<br></br><br></br>We apologise for any inconvenience caused. If you have any questions, please send us an email via <a>support@senzolive.com</a> <br></br><br></br>Thank you.
                    </div>
                </Modal>
            </React.Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/overview/index.jsx